import { NavLink as RouterLink } from "react-router-dom"
import {
  Box,
  Container,
  Flex,
  Grid,
  Heading,
  IconButton,
} from "@chakra-ui/react"
import { ArrowBackIcon, HamburgerIcon } from "@chakra-ui/icons"

const Header = ({ title, back, isLoading, toolbar, onOpen }) => (
  <Box as="header" p={4} bg="gray.200">
    <Container maxW="container.2xl">
      <Grid templateColumns="1fr auto" gap={4} alignItems="center">
        <Flex align="center">
          <IconButton
            icon={<HamburgerIcon />}
            isRound
            variant="ghost"
            onClick={onOpen}
            mr={4}
            display={{ base: "inline", lg: "none" }}
          />
          {back !== undefined && (
            <IconButton
              icon={<ArrowBackIcon />}
              isRound
              variant="ghost"
              as={RouterLink}
              to={back}
              mr={4}
            />
          )}
          <Heading as="h4" size="md">
            {title}
          </Heading>
        </Flex>
        <Grid autoFlow="column" h="2.5rem" gap={4}>
          {!isLoading && toolbar}
        </Grid>
      </Grid>
    </Container>
  </Box>
)

export default Header
